// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.btn-add-page {
  width: 75%;
  display: block;
  margin: 5px auto;
}

.square_btn {
  text-align: center;
  padding: 7px 20px;
  border-radius: 25px;
  border: 1px solid #5ea1d8;
  text-decoration: none;
  color: #5ea1d8;
  background-image: linear-gradient(45deg, white 0%, white 100%);
  transition: 0.4s;
  font-family: "Raleway";
}

.square_btn:hover {
  color: white;
  background-image: linear-gradient(45deg, #5ea1d8 0%, #5ea1d8 100%);
}

.square_btn {
  font-family: "Raleway";
  color: #5ea1d8;
}
.square_btn:hover {
  color: #fff;
}

.container {
  padding: 0px !important;
  max-height: 90vh;
  overflow-y: auto;
}

.box {
  max-width: 600px;
  width: 100% !important;
  margin: 10px;
  padding: 0px 25px;
  background: #fff;
  background-size: 50%;
  background-position: top center;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
  overflow: hidden;
  background: "https://flowchest-cdn.azureedge.net/mediaimage/Screenshot 2023-05-05 1448027cea2b039f4a4049a42ef2bcf6c81c54.png";
  background-size: cover;
  background-position: center;
  border-radius: 0px;
  margin: 0px auto;
  background-repeat: no-repeat !important;
  background-size: contain !important;
  background-size: 100% 90%;
  background-position: top center;
}

.donation-content {
  padding: 24px 24px 8px !important;
}
.donation-content .donation-field {
  width: 100%;
}

/* Nudge £ prefix down to sit on the same line as the typed number */
::ng-deep .donation-field .mat-mdc-form-field-icon-prefix,
::ng-deep .donation-field .mat-mdc-form-field-text-prefix {
  padding-top: 15px !important;
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 16px 24px;
  border-bottom: 1px solid #e4e8f0;
  position: relative;
}
.dialog-header h1 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  flex: 1;
}
.dialog-header .close-button {
  color: #6b7280;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  background: transparent;
  border: 1px solid transparent;
  padding: 0;
  margin: 0;
}
.dialog-header .close-button:hover {
  background: #f3f4f6;
  color: #374151;
  border-color: #e5e7eb;
}
.dialog-header .close-button:active {
  background: #e5e7eb;
  transform: scale(0.95);
}
.dialog-header .close-button:focus {
  outline: none;
}
.dialog-header .close-button:focus-visible {
  outline: none;
}
.dialog-header .close-button mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

:host-context(body.theme-dark) {
  /* Unified background across every region of the modal */
  /* mat-form-field fill appearance */
}
:host-context(body.theme-dark) .container,
:host-context(body.theme-dark) .box {
  background: #1e2535 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) ::ng-deep mat-dialog-content,
:host-context(body.theme-dark) ::ng-deep [mat-dialog-content],
:host-context(body.theme-dark) ::ng-deep .mat-mdc-dialog-content,
:host-context(body.theme-dark) ::ng-deep mat-dialog-actions,
:host-context(body.theme-dark) ::ng-deep [mat-dialog-actions],
:host-context(body.theme-dark) ::ng-deep .mat-mdc-dialog-actions {
  background: #1e2535 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .dialog-header {
  background: #1e2535 !important;
  border-bottom-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .dialog-header h1 {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .dialog-header .close-button {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .dialog-header .close-button:hover {
  background: #2d3748 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .dialog-header .close-button:active {
  background: #374151 !important;
}
:host-context(body.theme-dark) .dialog-header .close-button mat-icon {
  color: inherit !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field-focus-overlay,
:host-context(body.theme-dark) ::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: #2d3748 !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field .mdc-text-field--filled {
  background-color: #2d3748 !important;
}
:host-context(body.theme-dark) ::ng-deep .mdc-text-field--filled .mdc-floating-label,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-floating-label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) ::ng-deep .mdc-text-field--filled .mdc-text-field__input,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-input-element {
  color: #f1f5f9 !important;
  caret-color: #60a5fa !important;
}
:host-context(body.theme-dark) ::ng-deep .mdc-text-field--filled .mdc-line-ripple::before {
  border-bottom-color: rgba(148, 163, 184, 0.4) !important;
}
:host-context(body.theme-dark) ::ng-deep .mdc-text-field--filled .mdc-line-ripple::after {
  border-bottom-color: #60a5fa !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-subscript-wrapper {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field-prefix {
  color: #94a3b8 !important;
  display: inline-flex !important;
  align-items: center !important;
}
:host-context(body.theme-dark) .donation-content .donation-field .currency-prefix {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field-error {
  color: #f87171 !important;
}
:host-context(body.theme-dark) .square_btn {
  background-image: linear-gradient(45deg, #1e2535 0%, #1e2535 100%) !important;
  background-image: -webkit-linear-gradient(45deg, #1e2535 0%, #1e2535 100%) !important;
  color: #60a5fa !important;
  border-color: #60a5fa !important;
}
:host-context(body.theme-dark) .square_btn:hover {
  background-image: linear-gradient(45deg, #2563eb 0%, #2563eb 100%) !important;
  background-image: -webkit-linear-gradient(45deg, #2563eb 0%, #2563eb 100%) !important;
  color: #fff !important;
  border-color: #2563eb !important;
}
:host-context(body.theme-dark) .square_btn:disabled {
  opacity: 0.45 !important;
  border-color: rgba(148, 163, 184, 0.4) !important;
  color: #64748b !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/donation-popup/donation-popup.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,UAAA;EACA,cAAA;EACA,gBAAA;AAEJ;;AACE;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EAEA,8DAAA;EAEA,gBAAA;EACA,sBAAA;AACJ;;AAGE;EACE,YAAA;EAEA,kEAAA;AAAJ;;AAIE;EAEE,sBAAA;EACA,cAAA;AAFJ;AAGI;EACE,WAAA;AADN;;AAKE;EACE,uBAAA;EACA,gBAAA;EACA,gBAAA;AAFJ;;AAIE;EACE,gBAAA;EACA,sBAAA;EAEA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8EAAA;EACA,gBAAA;EACA,6HAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,uCAAA;EACA,mCAAA;EACA,yBAAA;EACA,+BAAA;AAFJ;;AAIE;EACE,iCAAA;AADJ;AAGI;EACE,WAAA;AADN;;AAKE,oEAAA;AACA;;EAEE,4BAAA;AAFJ;;AAKE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,4BAAA;EACA,gCAAA;EACA,kBAAA;AAFJ;AAII;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,OAAA;AAFN;AAKI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,uBAAA;EACA,6BAAA;EACA,UAAA;EACA,SAAA;AAHN;AAKM;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAHR;AAMM;EACE,mBAAA;EACA,sBAAA;AAJR;AAOM;EACE,aAAA;AALR;AAQM;EACE,aAAA;AANR;AASM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPR;;AAYA;EACE,wDAAA;EA6CA,mCAAA;AArDF;AASE;;EAEE,8BAAA;EACA,yBAAA;AAPJ;AAUE;;;;;;EAME,8BAAA;EACA,yBAAA;AARJ;AAYE;EACE,8BAAA;EACA,wDAAA;AAVJ;AAYI;EACE,yBAAA;AAVN;AAaI;EACE,yBAAA;AAXN;AAaM;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAXR;AAcM;EACE,8BAAA;AAZR;AAeM;EACE,yBAAA;AAbR;AAmBE;;EAEE,oCAAA;AAjBJ;AAoBE;EACE,oCAAA;AAlBJ;AAqBE;;EAEE,yBAAA;AAnBJ;AAsBE;;EAEE,yBAAA;EACA,+BAAA;AApBJ;AAuBE;EACE,wDAAA;AArBJ;AAwBE;EACE,uCAAA;AAtBJ;AAyBE;EACE,yBAAA;AAvBJ;AA0BE;EACE,yBAAA;EACA,+BAAA;EACA,8BAAA;AAxBJ;AA2BE;EACE,yBAAA;AAzBJ;AA4BE;EACE,yBAAA;AA1BJ;AA6BE;EACE,6EAAA;EACA,qFAAA;EACA,yBAAA;EACA,gCAAA;AA3BJ;AA6BI;EACE,6EAAA;EACA,qFAAA;EACA,sBAAA;EACA,gCAAA;AA3BN;AA8BI;EACE,wBAAA;EACA,iDAAA;EACA,yBAAA;AA5BN","sourcesContent":[".btn-add-page {\n    width: 75%;\n    display: block;\n    margin: 5px auto;\n  }\n  \n  .square_btn {\n    text-align: center;\n    padding: 7px 20px;\n    border-radius: 25px;\n    border: 1px solid #5ea1d8;\n    text-decoration: none;\n    color: #5ea1d8;\n    background-image: -webkit-linear-gradient(45deg, white 0%, white 100%);\n    background-image: linear-gradient(45deg, white 0%, white 100%);\n  \n    transition: 0.4s;\n    font-family: \"Raleway\";\n  }\n  \n  \n  .square_btn:hover {\n    color: white;\n    background-image: -webkit-linear-gradient(45deg, #5ea1d8 0%, #5ea1d8 100%);\n    background-image: linear-gradient(45deg, #5ea1d8 0%, #5ea1d8 100%);\n  }\n  \n  \n  .square_btn {\n   \n    font-family: \"Raleway\";\n    color: #5ea1d8;\n    &:hover {\n      color: #fff;\n    }\n  }\n  \n  .container {\n    padding: 0px !important;\n    max-height:90vh;\n    overflow-y: auto;\n  }\n  .box {\n    max-width: 600px;\n    width: 100% !important;\n    // max-height:90vh;\n    margin: 10px;\n    padding: 0px 25px;\n    background: #fff;\n    background-size: 50%;\n    background-position: top center;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 5px 11px 0 rgb(0 0 0 / 18%), 0 4px 15px 0 rgb(0 0 0 / 15%);\n    overflow: hidden;\n    background: \"https://flowchest-cdn.azureedge.net/mediaimage/Screenshot 2023-05-05 1448027cea2b039f4a4049a42ef2bcf6c81c54.png\";\n    background-size: cover;\n    background-position: center;\n    border-radius:0px;\n    margin: 0px auto;\n    background-repeat: no-repeat !important;\n    background-size: contain !important;\n    background-size: 100% 90%;\n    background-position: top center;\n  }\n  .donation-content {\n    padding: 24px 24px 8px !important;\n\n    .donation-field {\n      width: 100%;\n    }\n  }\n\n  /* Nudge £ prefix down to sit on the same line as the typed number */\n  ::ng-deep .donation-field .mat-mdc-form-field-icon-prefix,\n  ::ng-deep .donation-field .mat-mdc-form-field-text-prefix {\n    padding-top: 15px !important;\n  }\n\n  .dialog-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px 24px 16px 24px;\n    border-bottom: 1px solid #e4e8f0;\n    position: relative;\n\n    h1 {\n      margin: 0;\n      font-size: 20px;\n      font-weight: 600;\n      color: #111827;\n      flex: 1;\n    }\n\n    .close-button {\n      color: #6b7280;\n      width: 40px;\n      height: 40px;\n      min-width: 40px;\n      min-height: 40px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: all 0.2s ease;\n      background: transparent;\n      border: 1px solid transparent;\n      padding: 0;\n      margin: 0;\n\n      &:hover {\n        background: #f3f4f6;\n        color: #374151;\n        border-color: #e5e7eb;\n      }\n\n      &:active {\n        background: #e5e7eb;\n        transform: scale(0.95);\n      }\n\n      &:focus {\n        outline: none;\n      }\n\n      &:focus-visible {\n        outline: none;\n      }\n\n      mat-icon {\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n        line-height: 20px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n  }\n\n:host-context(body.theme-dark) {\n  /* Unified background across every region of the modal */\n  .container,\n  .box {\n    background: #1e2535 !important;\n    color: #e2e8f0 !important;\n  }\n\n  ::ng-deep mat-dialog-content,\n  ::ng-deep [mat-dialog-content],\n  ::ng-deep .mat-mdc-dialog-content,\n  ::ng-deep mat-dialog-actions,\n  ::ng-deep [mat-dialog-actions],\n  ::ng-deep .mat-mdc-dialog-actions {\n    background: #1e2535 !important;\n    color: #e2e8f0 !important;\n  }\n\n\n  .dialog-header {\n    background: #1e2535 !important;\n    border-bottom-color: rgba(148, 163, 184, 0.2) !important;\n\n    h1 {\n      color: #f1f5f9 !important;\n    }\n\n    .close-button {\n      color: #94a3b8 !important;\n\n      &:hover {\n        background: #2d3748 !important;\n        color: #e2e8f0 !important;\n        border-color: rgba(148, 163, 184, 0.2) !important;\n      }\n\n      &:active {\n        background: #374151 !important;\n      }\n\n      mat-icon {\n        color: inherit !important;\n      }\n    }\n  }\n\n  /* mat-form-field fill appearance */\n  ::ng-deep .mat-mdc-form-field-focus-overlay,\n  ::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) {\n    background-color: #2d3748 !important;\n  }\n\n  ::ng-deep .mat-mdc-form-field .mdc-text-field--filled {\n    background-color: #2d3748 !important;\n  }\n\n  ::ng-deep .mdc-text-field--filled .mdc-floating-label,\n  ::ng-deep .mat-mdc-floating-label {\n    color: #94a3b8 !important;\n  }\n\n  ::ng-deep .mdc-text-field--filled .mdc-text-field__input,\n  ::ng-deep .mat-mdc-input-element {\n    color: #f1f5f9 !important;\n    caret-color: #60a5fa !important;\n  }\n\n  ::ng-deep .mdc-text-field--filled .mdc-line-ripple::before {\n    border-bottom-color: rgba(148, 163, 184, 0.4) !important;\n  }\n\n  ::ng-deep .mdc-text-field--filled .mdc-line-ripple::after {\n    border-bottom-color: #60a5fa !important;\n  }\n\n  ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-subscript-wrapper {\n    color: #94a3b8 !important;\n  }\n\n  ::ng-deep .mat-mdc-form-field-prefix {\n    color: #94a3b8 !important;\n    display: inline-flex !important;\n    align-items: center !important;\n  }\n\n  .donation-content .donation-field .currency-prefix {\n    color: #94a3b8 !important;\n  }\n\n  ::ng-deep .mat-mdc-form-field-error {\n    color: #f87171 !important;\n  }\n\n  .square_btn {\n    background-image: linear-gradient(45deg, #1e2535 0%, #1e2535 100%) !important;\n    background-image: -webkit-linear-gradient(45deg, #1e2535 0%, #1e2535 100%) !important;\n    color: #60a5fa !important;\n    border-color: #60a5fa !important;\n\n    &:hover {\n      background-image: linear-gradient(45deg, #2563eb 0%, #2563eb 100%) !important;\n      background-image: -webkit-linear-gradient(45deg, #2563eb 0%, #2563eb 100%) !important;\n      color: #fff !important;\n      border-color: #2563eb !important;\n    }\n\n    &:disabled {\n      opacity: 0.45 !important;\n      border-color: rgba(148, 163, 184, 0.4) !important;\n      color: #64748b !important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
